import { render, staticRenderFns } from "./OrganizationStaffRoleRow.vue?vue&type=template&id=46ee3b16&"
import script from "./OrganizationStaffRoleRow.vue?vue&type=script&lang=js&"
export * from "./OrganizationStaffRoleRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports